import { ComponentProps } from "react";
import {
  DialogCloseTrigger,
  DialogHeader,
  HStack,
} from "@vygruppen/spor-react";
import { FCWC } from "shared/utils/FCWC";

type DialogHeaderProps = ComponentProps<typeof DialogHeader>;
export const InternalDropsDialogHeader: FCWC<DialogHeaderProps> = ({
  children,
  ...props
}) => (
  <HStack w="100%">
    <DialogHeader
      pt="24px"
      pb="18px"
      style={{ fontSize: "24px", fontWeight: 600 }}
      flex={1}
      {...props}
    >
      {children}
    </DialogHeader>
    <DialogCloseTrigger position="absolute" />
  </HStack>
);
